import { SettingOutlined } from "@ant-design/icons";
import { Checkbox, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import "./settingsColumns.scss";

function SettingsColumns(props: any) {
  const [isRotated, setRotated] = useState(false);

  const hendleChangeChecked = (e: any, item: any) => {
    let copyItem = [...props.listActiveColumns];
    let findO = copyItem.find((el: any) => el.text === item.text);
    findO.active = !findO.active;

    props.chengeSettingOptionFunc(copyItem);
  };

  return (
    <div className="component-set">
      <Popconfirm
        title="Izbor kolona"
        description={props.listActiveColumns?.map((item: any) => {
          return (
            <div>
              <Checkbox
                className={`checkbox-r`}
                checked={item?.active}
                onChange={(e) => {
                  hendleChangeChecked(e, item);
                }}
              />
              {item.text}
            </div>
          );
        })}
        rootClassName="custom-popconfirm"
      >
        <div className="icon-set">
          <SettingOutlined
            className={`setting-icon-r ${isRotated && "rotate-active"}`}
            onClick={() => {
              setRotated(!isRotated);
            }}
          />
        </div>
      </Popconfirm>
    </div>
  );
}

export default SettingsColumns;
